import { defineStyleConfig } from '@chakra-ui/react';

const dividerTheme = defineStyleConfig({
    baseStyle: {
        borderColor: 'border',
        opacity: 1,
    },
});

export default dividerTheme;
